// import React from "react";
// import "./RoomFacilities.css";



// import {
//   FaStar,
//   FaWifi,
//   FaBus,
// //   FaBellConcierge,
//   FaDumbbell,
//   FaSpa,
//   FaWheelchair,
//   FaSquareParking,
//   FaSmokingBan,
//   FaUmbrellaBeach,
//   FaCoffee,
//   FaBed,
//   FaBath,
//   FaTree,
//   FaPersonWalking,
//   FaTv,
//   FaBellConcierge,
//   FaChildren,
//   FaSoap,
//   FaBriefcase,
//   FaShieldHalved,
//   FaBuilding,
//   FaLanguage
// } from "react-icons/fa6";

// const Facilities = ({property}) => {
//   return (
//     <div className="container">
//       <h2>
//         Facilities of {property?.propertyName || "Hotel Details"}
//       </h2>

//       {/* Most Popular Facilities */}
//       <div className="RoomFacilitites_popular">
//         <h3 className="RoomFacilitites_h3">
//           <FaStar /> Most popular facilities
//         </h3>
//         <div className="RoomFacilitites_popular-icons">
//           <div><FaWifi /> Free Wifi</div>
//           <div><FaBus /> Airport shuttle</div>
//           <div><FaBellConcierge /> Room service</div>
//           <div><FaDumbbell /> Fitness center</div>
//           <div><FaSpa /> Spa</div>
//           <div><FaWheelchair /> Facilities for disabled guests</div>
//           <div><FaSquareParking /> Free parking</div>
//           <div><FaSmokingBan /> Non-smoking rooms</div>
//           <div><FaUmbrellaBeach /> Beachfront</div>
//           <div><FaCoffee /> Breakfast</div>
//         </div>
//       </div>

//       {/* All Facilities Columns */}
//       <div className="RoomFacilitites_columns">
//         <div>
//           <h3 className="RoomFacilitites_h3"><FaBed /> Great for your stay</h3>
//           <ul className="RoomFacilitites_ul">
//             <li>Air conditioning</li>
//             <li>Parking</li>
//             <li>Free Wifi</li>
//             <li>Spa</li>
//             <li>Airport shuttle</li>
//             <li>Family rooms</li>
//             <li>Fitness center</li>
//             <li>Valet parking</li>
//             <li>Tour desk</li>
//             <li>Street parking</li>
//           </ul>

//           <h3 className="RoomFacilitites_h3"><FaBath /> Bathroom</h3>
//           <ul className="RoomFacilitites_ul"><li>Free toiletries</li></ul>

//           <h3 className="RoomFacilitites_h3"><FaBed /> Bedroom</h3>
//           <ul className="RoomFacilitites_ul"><li>Alarm clock</li></ul>

//           <h3 className="RoomFacilitites_h3"><FaTree /> Outdoors</h3>
//           <ul className="RoomFacilitites_ul"><li>Beachfront</li><li>Terrace</li></ul>

//           <h3 className="RoomFacilitites_h3"><FaPersonWalking /> Activities</h3>
//           <ul className="RoomFacilitites_ul"><li>Walking tours</li><li>Beach</li></ul>
//         </div>

//         <div>
//           <h3 className="RoomFacilitites_h3"><FaTv /> Media & Technology</h3>
//           <ul className="RoomFacilitites_ul"><li>Telephone</li></ul>

//           <h3 className="RoomFacilitites_h3"><FaWifi /> Internet</h3>
//           <ul className="RoomFacilitites_ul"><li>Wifi is available in all areas and is free of charge</li></ul>

//           <h3 className="RoomFacilitites_h3"><FaSquareParking /> Parking</h3>
//           <ul className="RoomFacilitites_ul">
//             <li>Free private parking (reservation is needed)</li>
//             <li>Street parking</li>
//             <li>Valet parking</li>
//             <li>Accessible parking</li>
//           </ul>

//           <h3 className="RoomFacilitites_h3"><FaBellConcierge /> Front Desk Services</h3>
//           <ul className="RoomFacilitites_ul">
//             <li>Lockers</li>
//             <li>Concierge</li>
//             <li>Baggage storage</li>
//             <li>Tour desk</li>
//             <li>24-hour front desk</li>
//           </ul>
//         </div>

//         <div>
//           <h3 className="RoomFacilitites_h3"><FaChildren /> Entertainment & Family Services</h3>
//           <ul className="RoomFacilitites_ul"><li>Babysitting/Child services (Additional charge)</li></ul>

//           <h3 className="RoomFacilitites_h3"><FaSoap /> Cleaning Services</h3>
//           <ul className="RoomFacilitites_ul">
//             <li>Suit press (Additional charge)</li>
//             <li>Ironing service (Additional charge)</li>
//             <li>Laundry (Additional charge)</li>
//           </ul>

//           <h3 className="RoomFacilitites_h3"><FaBriefcase /> Business Facilities</h3>
//           <ul className="RoomFacilitites_ul"><li>Business center (Additional charge)</li></ul>

//           <h3 className="RoomFacilitites_h3"><FaShieldHalved /> Safety & Security</h3>
//           <ul className="RoomFacilitites_ul">
//             <li>Fire extinguishers</li>
//             <li>Safe (Additional charge)</li>
//           </ul>
//         </div>

//         <div>
//           <h3 className="RoomFacilitites_h3"><FaBuilding /> General</h3>
//           <ul className="RoomFacilitites_ul">
//             <li>Shuttle service</li>
//             <li>Air conditioning</li>
//             <li>Heating</li>
//             <li>Car rental</li>
//             <li>Elevator</li>
//             <li>Family rooms</li>
//             <li>Facilities for disabled guests</li>
//             <li>Airport shuttle (Additional charge)</li>
//             <li>Non-smoking rooms</li>
//             <li>Room service</li>
//           </ul>

//           <h3 className="RoomFacilitites_h3"><FaSpa /> Spa</h3>
//           <ul className="RoomFacilitites_ul">
//             <li>Spa (Additional charge)</li>
//             <li>Fitness center</li>
//           </ul>

//           <h3 className="RoomFacilitites_h3"><FaLanguage /> Languages Spoken</h3>
//           <ul className="RoomFacilitites_ul">
//             {property.languagesSpoken?.map((lang, index) => (
//                 <li key={index}>{lang}</li>
//             ))}
//             </ul>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default Facilities;
























































// import React from "react";
// import "./RoomFacilities.css";
// import {
//   FaWifi,
//   FaBus,
//   FaDumbbell,
//   FaSpa,
//   FaWheelchair,
//   FaParking,
//   FaSmokingBan,
//   FaUmbrellaBeach,
//   FaCoffee,
//   FaBed,
//   FaBath,
//   FaTree,
//   FaPersonWalking,
//   FaTv,
//   FaConciergeBell,
//   FaBriefcase,
//   FaShieldAlt,
//   FaBuilding,
//   FaLanguage,
//   FaCar,
//   FaFutbol,
//   FaTint,
//   FaBicycle,
//   FaMusic,
//   FaFilm,
//   FaTheaterMasks,
//   FaUtensils,
// } from "react-icons/fa";


// // 🧩 Facility map — map property keys to icons and labels
// const facilityMap = {
//   wifi: { label: "Free Wifi", icon: <FaWifi /> },
//   airportShuttle: { label: "Airport Shuttle", icon: <FaBus /> },
//   roomService: { label: "Room Service", icon: <FaConciergeBell /> },
//   fitnessCenter: { label: "Fitness Center", icon: <FaDumbbell /> },
//   spa: { label: "Spa", icon: <FaSpa /> },
//   facilitiesForDisabled: { label: "Facilities for Disabled Guests", icon: <FaWheelchair /> },
//   parking: { label: "Parking", icon: <FaParking /> },
//   nonSmokingRooms: { label: "Non-Smoking Rooms", icon: <FaSmokingBan /> },
//   beach: { label: "Beachfront", icon: <FaUmbrellaBeach /> },
//   breakfast: { label: "Breakfast Included", icon: <FaCoffee /> },
//   airConditioning: { label: "Air Conditioning", icon: <FaBuilding /> },
//   familyRooms: { label: "Family Rooms", icon: <FaBed /> },
//   terrace: { label: "Terrace", icon: <FaTree /> },
//   garden: { label: "Garden", icon: <FaTree /> },
//   hotTubJacuzzi: { label: "Hot Tub / Jacuzzi", icon: <FaSpa /> },
//   swimmingPool: { label: "Swimming Pool", icon: <FaSpa /> },
//   bar: { label: "Bar", icon: <FaCoffee /> },
//   sauna: { label: "Sauna", icon: <FaSpa /> },
//   tv: { label: "Flat-screen TV", icon: <FaTv /> },
//   businessCenter: { label: "Business Center", icon: <FaBriefcase /> },
//   safetySecurity: { label: "Safety & Security", icon: <FaShieldAlt /> },
//   cleaningServices: { label: "Cleaning Services", icon: <FaBath /> },
//   selfCheckIn: { label: "Self Check-in Available", icon: <FaConciergeBell /> },
//   foodDrinkSafety: { label: "Food & Drink Safety", icon: <FaCoffee /> },
//   valetParking: { label: "Valet Parking", icon: <FaCar /> },
//   conciergeService: { label: "Concierge Service", icon: <FaConciergeBell /> },
//   petsAllowed: { label: "Pets Allowed", icon: <FaPersonWalking /> },
//   shuttleService: { label: "Shuttle Service", icon: <FaBus /> },

//   // 🏸 Activities & Entertainment
//   tennisEquipment: { label: "Tennis Equipment", icon: <FaBicycle /> },
//   badmintonEquipment: { label: "Badminton Equipment", icon: <FaBicycle /> },
//   artGalleries: { label: "Art Galleries", icon: <FaTheaterMasks /> },
//   barCrawls: { label: "Bar Crawls", icon: <FaCoffee /> },
//   standUpComedy: { label: "Stand-Up Comedy", icon: <FaTheaterMasks /> },
//   movieNights: { label: "Movie Nights", icon: <FaFilm /> },
//   walkingTours: { label: "Walking Tours", icon: <FaPersonWalking /> },
//   bikeTours: { label: "Bike Tours", icon: <FaBicycle /> },
//   themedDinners: { label: "Themed Dinners", icon: <FaUtensils /> },
//   happyHour: { label: "Happy Hour", icon: <FaCoffee /> },
//   localCultureTour: { label: "Local Culture Tour", icon: <FaPersonWalking /> },
//   cookingClass: { label: "Cooking Class", icon: <FaUtensils /> },
//   liveMusic: { label: "Live Music", icon: <FaMusic /> },
//   liveSports: { label: "Live Sports", icon: <FaPersonWalking /> },
//   archery: { label: "Archery", icon: <FaPersonWalking /> },
//   aerobics: { label: "Aerobics", icon: <FaPersonWalking /> },
//   bingo: { label: "Bingo", icon: <FaPersonWalking /> },
//   tennisCourt: { label: "Tennis Court", icon: <FaBicycle /> },
//   poolTable: { label: "Pool Table", icon: <FaBicycle /> },
//   pingPong: { label: "Ping Pong", icon: <FaBicycle /> },
//   darts: { label: "Darts", icon: <FaBicycle /> },
//   racquetball: { label: "Racquetball", icon: <FaBicycle /> },
//   bowling: { label: "Bowling", icon: <FaBicycle /> },
//   miniGolf: { label: "Mini Golf", icon: <FaFutbol /> },
//   golfCourse: { label: "Golf Course", icon: <FaFutbol /> },
//   waterPark: { label: "Water Park", icon: <FaTint /> },
//   waterSportsFacilities: { label: "Water Sports Facilities", icon: <FaTint /> },
//   windsurfing: { label: "Windsurfing", icon: <FaTint /> },
//   diving: { label: "Diving", icon: <FaTint /> },
// };

// // 🧠 Helper to get active facilities from property
// const getActiveFacilities = (property, keys) =>
//   keys
//     .filter((key) => property[key] && Object.keys(property[key]).length > 0)
//     .map((key) => ({
//       key,
//       ...facilityMap[key],
//     }));

// const Facilities = ({ property }) => {
//   if (!property) return null;

//   const sections = [
//     {
//       title: "Great for your stay",
//       icon: <FaBed />,
//       keys: ["airConditioning", "parking", "wifi", "spa", "airportShuttle", "familyRooms", "fitnessCenter", "valetParking", "conciergeService"],
//     },
//     { title: "Bathroom", icon: <FaBath />, keys: ["hotTubJacuzzi", "sauna", "cleaningServices"] },
//     { title: "Outdoors & Recreation", icon: <FaTree />, keys: ["garden", "terrace", "beach", "swimmingPool", "bar", "petsAllowed"] },
//     { title: "Media & Technology", icon: <FaTv />, keys: ["tv"] },
//     { title: "Business & Safety", icon: <FaShieldAlt />, keys: ["businessCenter", "safetySecurity", "roomService", "shuttleService"] },
//     { title: "Self Check-In & Food", icon: <FaConciergeBell />, keys: ["selfCheckIn", "foodDrinkSafety", "breakfast"] },
//     {
//       title: "Activities & Sports",
//       icon: <FaBicycle />,
//       keys: [
//         "tennisEquipment","badmintonEquipment","artGalleries","barCrawls","standUpComedy","movieNights","walkingTours","bikeTours",
//         "themedDinners","happyHour","localCultureTour","cookingClass","liveMusic","liveSports","archery","aerobics","bingo",
//         "tennisCourt","poolTable","pingPong","darts","racquetball","bowling","miniGolf","golfCourse","waterPark","waterSportsFacilities","windsurfing","diving"
//       ],
//     },
//   ];

//   return (
//     <div className="container">
//       <h2>Facilities of {property?.propertyName || "Hotel Details"}</h2>

//       <div className="RoomFacilitites_columns">
//         {sections.map((section, i) => {
//           const active = getActiveFacilities(property, section.keys);
//           if (active.length === 0) return null;

//           return (
//             <div key={i}>
//               <h3 className="RoomFacilitites_h3">
//                 {section.icon} {section.title}
//               </h3>
//               <ul className="RoomFacilitites_ul">
//                 {active.map((fac, j) => (
//                   <li key={j}>
//                     {fac.icon} {fac.label}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           );
//         })}

//         {property.languagesSpoken?.length > 0 && (
//           <div>
//             <h3 className="RoomFacilitites_h3">
//               <FaLanguage /> Languages Spoken
//             </h3>
//             <ul className="RoomFacilitites_ul">
//               {property.languagesSpoken.map((lang, index) => (
//                 <li key={index}>{lang}</li>
//               ))}
//             </ul>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Facilities;


















import React from "react";
import "./RoomFacilities.css";
import {
  FaWifi,
  FaBus,
  FaDumbbell,
  FaSpa,
  FaWheelchair,
  FaParking,
  FaBan,
  FaUmbrellaBeach,
  FaCoffee,
  FaBed,
  FaBath,
  FaTree,
  FaWalking,
  FaTv,
  FaConciergeBell,
  FaBriefcase,
  FaShieldAlt,
  FaBuilding,
  FaLanguage,
  FaCar,
  FaFutbol,
  FaTint,
  FaBicycle,
  FaMusic,
  FaFilm,
  FaTheaterMasks,
  FaUtensils,
} from "react-icons/fa";

// 🧩 Facility map
const facilityMap = {
  wifi: { label: "Free Wifi", icon: <FaWifi /> },
  airportShuttle: { label: "Airport Shuttle", icon: <FaBus /> },
  roomService: { label: "Room Service", icon: <FaConciergeBell /> },
  fitnessCenter: { label: "Fitness Center", icon: <FaDumbbell /> },
  spa: { label: "Spa", icon: <FaSpa /> },
  facilitiesForDisabled: {
    label: "Facilities for Disabled Guests",
    icon: <FaWheelchair />,
  },
  parking: { label: "Parking", icon: <FaParking /> },
  nonSmokingRooms: { label: "Non-Smoking Rooms", icon: <FaBan /> },
  beach: { label: "Beachfront", icon: <FaUmbrellaBeach /> },
  breakfast: { label: "Breakfast Included", icon: <FaCoffee /> },
  airConditioning: { label: "Air Conditioning", icon: <FaBuilding /> },
  familyRooms: { label: "Family Rooms", icon: <FaBed /> },
  terrace: { label: "Terrace", icon: <FaTree /> },
  garden: { label: "Garden", icon: <FaTree /> },
  hotTubJacuzzi: { label: "Hot Tub / Jacuzzi", icon: <FaSpa /> },
  swimmingPool: { label: "Swimming Pool", icon: <FaSpa /> },
  bar: { label: "Bar", icon: <FaCoffee /> },
  sauna: { label: "Sauna", icon: <FaSpa /> },
  tv: { label: "Flat-screen TV", icon: <FaTv /> },
  businessCenter: { label: "Business Center", icon: <FaBriefcase /> },
  safetySecurity: { label: "Safety & Security", icon: <FaShieldAlt /> },
  cleaningServices: { label: "Cleaning Services", icon: <FaBath /> },
  selfCheckIn: { label: "Self Check-in Available", icon: <FaConciergeBell /> },
  foodDrinkSafety: { label: "Food & Drink Safety", icon: <FaCoffee /> },
  valetParking: { label: "Valet Parking", icon: <FaCar /> },
  conciergeService: { label: "Concierge Service", icon: <FaConciergeBell /> },
  petsAllowed: { label: "Pets Allowed", icon: <FaWalking /> },
  shuttleService: { label: "Shuttle Service", icon: <FaBus /> },

  // 🏸 Activities & Entertainment
  tennisEquipment: { label: "Tennis Equipment", icon: <FaBicycle /> },
  badmintonEquipment: { label: "Badminton Equipment", icon: <FaBicycle /> },
  artGalleries: { label: "Art Galleries", icon: <FaTheaterMasks /> },
  barCrawls: { label: "Bar Crawls", icon: <FaCoffee /> },
  standUpComedy: { label: "Stand-Up Comedy", icon: <FaTheaterMasks /> },
  movieNights: { label: "Movie Nights", icon: <FaFilm /> },
  walkingTours: { label: "Walking Tours", icon: <FaWalking /> },
  bikeTours: { label: "Bike Tours", icon: <FaBicycle /> },
  themedDinners: { label: "Themed Dinners", icon: <FaUtensils /> },
  happyHour: { label: "Happy Hour", icon: <FaCoffee /> },
  localCultureTour: { label: "Local Culture Tour", icon: <FaWalking /> },
  cookingClass: { label: "Cooking Class", icon: <FaUtensils /> },
  liveMusic: { label: "Live Music", icon: <FaMusic /> },
  liveSports: { label: "Live Sports", icon: <FaFutbol /> },
  archery: { label: "Archery", icon: <FaFutbol /> },
  aerobics: { label: "Aerobics", icon: <FaWalking /> },
  bingo: { label: "Bingo", icon: <FaWalking /> },
  tennisCourt: { label: "Tennis Court", icon: <FaBicycle /> },
  poolTable: { label: "Pool Table", icon: <FaBicycle /> },
  pingPong: { label: "Ping Pong", icon: <FaBicycle /> },
  darts: { label: "Darts", icon: <FaBicycle /> },
  racquetball: { label: "Racquetball", icon: <FaBicycle /> },
  bowling: { label: "Bowling", icon: <FaBicycle /> },
  miniGolf: { label: "Mini Golf", icon: <FaFutbol /> },
  golfCourse: { label: "Golf Course", icon: <FaFutbol /> },
  waterPark: { label: "Water Park", icon: <FaTint /> },
  waterSportsFacilities: { label: "Water Sports Facilities", icon: <FaTint /> },
  windsurfing: { label: "Windsurfing", icon: <FaTint /> },
  diving: { label: "Diving", icon: <FaTint /> },
};

// 🧠 Helper
const getActiveFacilities = (property, keys) =>
  keys
    .filter((key) => property[key] && Object.keys(property[key]).length > 0)
    .map((key) => ({
      key,
      ...facilityMap[key],
    }));

const Facilities = ({ property }) => {
  if (!property) return null;

  const sections = [
    {
      title: "Great for your stay",
      icon: <FaBed />,
      keys: [
        "airConditioning",
        "parking",
        "wifi",
        "spa",
        "airportShuttle",
        "familyRooms",
        "fitnessCenter",
        "valetParking",
        "conciergeService",
      ],
    },
    {
      title: "Bathroom",
      icon: <FaBath />,
      keys: ["hotTubJacuzzi", "sauna", "cleaningServices"],
    },
    {
      title: "Outdoors & Recreation",
      icon: <FaTree />,
      keys: ["garden", "terrace", "beach", "swimmingPool", "bar", "petsAllowed"],
    },
    { title: "Media & Technology", icon: <FaTv />, keys: ["tv"] },
    {
      title: "Business & Safety",
      icon: <FaShieldAlt />,
      keys: ["businessCenter", "safetySecurity", "roomService", "shuttleService"],
    },
    {
      title: "Self Check-In & Food",
      icon: <FaConciergeBell />,
      keys: ["selfCheckIn", "foodDrinkSafety", "breakfast"],
    },
    {
      title: "Activities & Sports",
      icon: <FaBicycle />,
      keys: [
        "tennisEquipment",
        "badmintonEquipment",
        "artGalleries",
        "barCrawls",
        "standUpComedy",
        "movieNights",
        "walkingTours",
        "bikeTours",
        "themedDinners",
        "happyHour",
        "localCultureTour",
        "cookingClass",
        "liveMusic",
        "liveSports",
        "archery",
        "aerobics",
        "bingo",
        "tennisCourt",
        "poolTable",
        "pingPong",
        "darts",
        "racquetball",
        "bowling",
        "miniGolf",
        "golfCourse",
        "waterPark",
        "waterSportsFacilities",
        "windsurfing",
        "diving",
      ],
    },
  ];

  return (
    <div className="container">
      <h2>Facilities of {property?.propertyName || "Hotel Details"}</h2>
      <div className="RoomFacilitites_columns">
        {sections.map((section, i) => {
          const active = getActiveFacilities(property, section.keys);
          if (active.length === 0) return null;

          return (
            <div key={i}>
              <h3 className="RoomFacilitites_h3">
                {section.icon} {section.title}
              </h3>
              <ul className="RoomFacilitites_ul">
                {active.map((fac, j) => (
                  <li key={j}>
                    {fac.icon} {fac.label}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
        {property.languagesSpoken?.length > 0 && (
          <div>
            <h3 className="RoomFacilitites_h3">
              <FaLanguage /> Languages Spoken
            </h3>
            <ul className="RoomFacilitites_ul">
              {property.languagesSpoken.map((lang, index) => (
                <li key={index}>{lang}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Facilities;
